// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__xbly1","sideSprite":"style__sideSprite__5vM1k","middleSprite":"style__middleSprite__Uzn0V"};